import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';

interface ExamEventDetailsPermissionRouteProps {
  examCenterCode: string;
  examEventId: string;
}

export default function ExamEventDetailsPermissionRoute(
  props: Readonly<ExamEventDetailsPermissionRouteProps>,
) {
  const { examCenterCode, examEventId } = props;

  const routes: PermissionRouteData[] = [
    {
      path: '/:examCenterCode/exam-events/:examEventId',
      params: { examEventId, examCenterCode },
      requiredPermission: APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
    },
    {
      path: '/:examCenterCode/exam-events/:examEventId/examinees',
      params: { examEventId, examCenterCode },
      requiredPermission: APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
    },
    {
      path: '/:examCenterCode/exam-events/:examEventId/results',
      params: { examEventId, examCenterCode },
      requiredPermission: APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
    },
  ];

  return <PermissionRoute routes={routes} />;
}
